import * as moment from 'moment';

export const getters = {
    selectedChild: state => state.selectedChild,

    activityCalendarDate: state => state.date,

    activityCalendarMode: state => state.mode,

    getActivitiesByDate: state => day => {
        const date = moment(day).format('YYYY-MM-DD');
        const activities = state.activityDates[date];
        activities && activities.forEach(activity => activity.key = Math.random() * 10);
        return activities ?
            activities.map(activity => {
                const [fromHours, fromMinutes] = activity.timeFrom.split(':');
                const [toHours, toMinutes] = activity.timeTo.split(':');
                return {
                    ...activity,
                    timeFrom: moment(date).hours(fromHours).minutes(fromMinutes).toDate(),
                    timeTo: moment(date).hours(toHours).minutes(toMinutes).toDate()
                }
            }):
            [];
    },

    getActivitiesByDateAndTime: (state, getters) => (day, timeFrom) => {
        const getActivitiesByDate = getters.getActivitiesByDate;
        const previousDate = moment(day).subtract(1, 'day').toDate();
        const notEndedActivitiesStartedOn = getNotEndedActivitiesStartedOnDay(previousDate, timeFrom, getActivitiesByDate);
        const currentDateActivities = getActivitiesByDate(day)
            .filter(activity => activityBelongsToTimeInterval(activity, timeFrom));

        return [...currentDateActivities, ...notEndedActivitiesStartedOn];
    },

    isCalendarChildDropdown: state => state.isChildDropdown,
};

function activityBelongsToTimeInterval(activity, timeFrom) {
    return moment(timeFrom).date(activity.timeFrom.getDate()).month(activity.timeFrom.getMonth()).year(activity.timeFrom.getFullYear())
            .isSame(activity.timeFrom, 'hours') &&
        moment(timeFrom).date(activity.timeFrom.getDate()).month(activity.timeFrom.getMonth()).year(activity.timeFrom.getFullYear()).add(1, 'hours')
            .isSameOrAfter(activity.timeFrom, 'hours');
}

function getNotEndedActivitiesStartedOnDay(day, timeFrom, getter) {
    let result = [];
    if (moment(timeFrom).hours() === 0) {
        const previousDateActivities = getter(day)
            .filter(activity => moment(activity.timeFrom).isAfter(activity.timeTo, 'hours'));
        result.push(...previousDateActivities);
    }
    return result;
}


// WEBPACK FOOTER //
// ./src/store/modules/calendar/getters.js